import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

// Stagiaire stagiaire STAGIAIRE 
 
import {
    userLoginReducer,
    userRegisterReducer,
    userAddReducer,
    userDetailsReducer,
    userUpdateProfileReducer,
    userListeReducer,
    userDeleteReducer,
    userUpdateReducer
} from './reducers/userReducer.js'

import {
    stagiaireLoginReducer,
    stagiaireRegisterReducer,
    stagiaireAddReducer,
    stagiaireDetailsReducer,
    stagiaireUpdateProfileReducer,
    stagiaireListeReducer,
    stagiaireDeleteReducer,
    stagiaireUpdateReducer
} from './reducers/stagiaireReducer.js'

import {
    catalogLoginReducer,
    catalogRegisterReducer,
    catalogDetailsReducer,
    catalogUpdateProfileReducer,
    catalogListeReducer,
    catalogDeleteReducer,
    catalogUpdateReducer
} from './reducers/catalogReducer.js'

import {
    newsflashLoginReducer,
    newsflashRegisterReducer,
    newsflashDetailsReducer,
    newsflashUpdateProfileReducer,
    newsflashListeReducer,
    newsflashDeleteReducer,
    newsflashUpdateReducer
} from './reducers/newsflashReducer.js'

const reducer = combineReducers({
    userLogin: userLoginReducer,
    userRegister: userRegisterReducer,
    userAdd: userAddReducer,
    userDetails: userDetailsReducer,
    userUpdateProfile: userUpdateProfileReducer,
    userList: userListeReducer,
    userDelete: userDeleteReducer,
    userUpdate: userUpdateReducer,

    stagiaireLogin: stagiaireLoginReducer,
    stagiaireRegister: stagiaireRegisterReducer,
    stagiaireAdd: stagiaireAddReducer,
    stagiaireDetails: stagiaireDetailsReducer,
    stagiaireUpdateProfile: stagiaireUpdateProfileReducer,
    stagiaireList: stagiaireListeReducer,
    stagiaireDelete: stagiaireDeleteReducer,
    stagiaireUpdate: stagiaireUpdateReducer,
    
    catalogLogin: catalogLoginReducer,
    catalogRegister: catalogRegisterReducer,
    catalogDetails: catalogDetailsReducer,
    catalogUpdateProfile: catalogUpdateProfileReducer,
    catalogList: catalogListeReducer,
    catalogDelete: catalogDeleteReducer,
    catalogUpdate: catalogUpdateReducer,

    newsflashLogin: newsflashLoginReducer,
    newsflashRegister: newsflashRegisterReducer,
    newsflashDetails: newsflashDetailsReducer,
    newsflashUpdateProfile: newsflashUpdateProfileReducer,
    newsflashList: newsflashListeReducer,
    newsflashDelete: newsflashDeleteReducer,
    newsflashUpdate: newsflashUpdateReducer
})

//const cartItemsFromStorage = localStorage.getItem('cartItems')
  //  ? JSON.parse(localStorage.getItem('cartItems'))
   // : []

const userInfoFromStorage = localStorage.getItem('userInfo')
    ? JSON.parse(localStorage.getItem('userInfo'))
    : null

    const stagiaireInfoFromStorage = localStorage.getItem('stagiaireInfo')
    ? JSON.parse(localStorage.getItem('stagiaireInfo'))
    : null

const catalogInfoFromStorage = localStorage.getItem('catalogInfo')
    ? JSON.parse(localStorage.getItem('catalogInfo'))
    : null

const newsflashInfoFromStorage = localStorage.getItem('newsflashInfo')
    ? JSON.parse(localStorage.getItem('newsflashInfo'))
    : null

    
const initialState = {
  
   // catalogRegister: { catalogInfo: catalogInfoFromStorage    },

   // newsflashRegister: { newsflashInfo: newsflashInfoFromStorage     },


    userLogin: { userInfo: userInfoFromStorage     } ,

    stagiaireRegister: { stagiaireInfo: stagiaireInfoFromStorage     } ,

}



const middleware = [thunk]

const store = createStore(
    reducer,
    initialState,
    
    composeWithDevTools(applyMiddleware(...middleware))
)

export default store


